var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"jax",staticClass:"formula",domProps:{"innerHTML":_vm._s(_vm.formula)}})
}
var staticRenderFns = []

export { render, staticRenderFns }